<template>
    <div style="position: relative" class="fullsize">
        <div
            style="margin: 0; font-weight: bold; font-size: 200%; position: absolute; top: 5%; left: 5%; z-index: 100000">
            <slot></slot>
        </div>
        <LoadingCards :counting="true" style="z-index: 1000" class="loadingBar"/>
    </div>
</template>

<script>
import {aircraftConfig} from "@/config";
import LoadingCards from "@/components/LoadingCards";

export default {
    name: "LoadingAsset",
    components: {LoadingCards}
}
</script>

<style scoped>

.fullsize {
  height: 100vh;
  width: 100vw;
}

.loading-spinner{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loadingBar {
    position: absolute;
    bottom: 30px;
}

</style>
